import React from "react"
import { render } from "react-dom"
import camelcase from "camelcase"

export const propNameAndValue = (attrName: string, value: string) => {
  const parts = attrName.split(":")
  let propName = parts[0].startsWith("data-") ? parts[0] : camelcase(parts[0])
  let propType = parts[1] || "string"

  switch (propType) {
    case "string":
      return [propName, value]
    case "boolean":
      switch (value) {
        case "true":
          return [propName, true]
        case "false":
          return [propName, false]
        default:
          throw `Invalid value for attribute '${attrName}': '${value}'`
      }
    case "number":
      return [propName, Number(value)]
    case "json":
      return [propName, JSON.parse(value)]
    default:
      throw `Invalid type ${propType} for attribute '${attrName}'`
  }
}

let reactComponentWrapper = (reactComponent: any) => {
  return class ReactComponentWrapper extends HTMLElement {
    props: any
    constructor(...params) {
      super()
    }

    connectedCallback() {
      const mountPoint = document.createElement("span")
      this.appendChild(mountPoint)
      let componentProps = {}
      this.getAttributeNames().forEach((name) => {
        const [propName, propValue] = propNameAndValue(name, this.getAttribute(name))
        componentProps[propName] = propValue
      })

      render(React.createElement(reactComponent, componentProps), mountPoint)
    }
  }
}

export default function webify(elementName: string, component: any) {
  // This will be a no-op in the js tests, we should be testing the react components
  // instead.
  if (window.customElements) {
    window.customElements.define(elementName, reactComponentWrapper(component))
  }
}

let svelteComponentWrapper = (svelteComponent: any) => {
  return class SvelteComponentWrapper extends HTMLElement {
    props: any
    constructor(...params) {
      super()
    }

    connectedCallback() {
      let componentProps = {}
      this.getAttributeNames().forEach((name) => {
        const [propName, propValue] = propNameAndValue(name, this.getAttribute(name))
        componentProps[propName] = propValue
      })

      new svelteComponent.default({
        target: this,
        props: componentProps,
      })
    }
  }
}

export function webifySvelte(elementName: string, component: any) {
  // This will be a no-op in the js tests, we should be testing the components instead.
  if (window.customElements) {
    window.customElements.define(elementName, svelteComponentWrapper(component))
  }
}
